var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-custom-field',{attrs:{"submit":_vm.submit,"formTitle":'Custom Field Details',"role":"update"}})}
var staticRenderFns = []

export { render, staticRenderFns }